<div class="mat-dialog">
  <div class="modal-header" tabindex="0">
    <h3 mat-dialog-title>{{ data.title }}</h3>
  </div>

  <div mat-dialog-content class="modal-dialog-content">
    <div class="question">
      <div class="content">
        <p>{{ data.message }}</p>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="modal-footer">
    <app-button variant="primary" (buttonClick)="onConfirm()">OK</app-button>
  </div>
</div>
